<script setup>
import Button from './button/Button.vue';
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
  closeIcon: {
    type: String,
    default: 'i-lucide-x',
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <div
    class="border-b border-n-weak"
  >
    <div class="flex items-center justify-between px-4 py-2 h-12">
      <div class="flex items-center justify-between gap-2 flex-1">
        <span class="text-[11px] font-black uppercase tracking-[0.2em] text-n-slate-12">{{ title }}</span>
        <div class="flex items-center">
          <Button
            v-for="button in buttons"
            :key="button.key"
            v-tooltip="button.tooltip"
            :icon="button.icon"
            :label="button.label"
            ghost
            sm
            :disabled="button.disabled"
            @click="handleButtonClick(button)"
          />
          <Button
            v-tooltip="$t('GENERAL.CLOSE')"
            :icon="closeIcon"
            ghost
            sm
            @click="$emit('close')"
          />
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>
